<template>
  <ContainerBody>
    <div class="ui divider horizontal">Mnemônicos Contrato</div>
    <TreeList
      label="Lista de Mnemônicos"
      :listItems="listMnemonicos"
      @addTextModal="copiarMnemonico"
    />
  </ContainerBody>
</template>
<script>
import ContainerBody from '@/components/ContainerBody.vue';
import api from '@/services/api';
import TreeList from '@/components/TreeList.vue';

export default {
  name: 'MnemonicosContrato',
  components: {
    ContainerBody,
    TreeList,
  },
  data() {
    return {
      listMnemonicos: [],
    };
  },
  async created() {
    await api.get('api/situacoes-contrato/mnemonicos/lista').then(result => {
      this.listMnemonicos = result.data;
    });
  },
  methods: {
    copiarMnemonico(placeholder) {
      if (placeholder.parent_id > 0 && placeholder.collectionPai && placeholder.placeholder != '') {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(placeholder.name).then(() => {
            this.$alertify.success('Copiado com Sucesso!!');
          });
        } else {
          this.$alertify.success('Erro ao Copiar');
        }
      }
    },
  },
};
</script>
